(function () {
  const initHeadingAnimation = (section) => {
    if (!section || !section?.classList.contains("collections-list-section")) {
      return;
    }
    const enableAnimation = section.querySelector(
      "[data-enable-header-animation]"
    );
    if (!enableAnimation) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const section = entry.target;
            section.classList.add("anim-active");
            observer.unobserve(section);
          }
        });
      },
      {
        threshold: 0,
        rootMargin: "0px 0px -25% 0px",
      }
    );
    observer.observe(section);
  };
  initHeadingAnimation(document.currentScript.parentElement);
  document.addEventListener("shopify:section:load", function (event) {
    initHeadingAnimation(event.target);
  });
})();
